<ul class="emma-pagination">
    <li (click)="onChangePage(0)" [ngClass]="{ disabled: !(curPage > 0) }">
        <i class="la la-angle-double-left" aria-hidden="true"></i>
    </li>
    <li (click)="onChangePage(curPage - 1)" [ngClass]="{ disabled: !(curPage > 0) }">
        <i class="la la-angle-left" aria-hidden="true"></i>
    </li>
    <ng-container *ngFor="let page of pages" [ngSwitch]="page">
        <li *ngSwitchCase="null" class="page-nr--separator">...</li>
        <li
            *ngSwitchDefault
            (click)="onChangePage(page)"
            [ngClass]="{ 'page-nr--current': curPage === page }"
        >
            {{ (page || 0) + 1 }}
        </li>
    </ng-container>
    <li (click)="onChangePage(curPage + 1)" [ngClass]="{ disabled: !(curPage < maxPage || hasMorePages) }">
        <i class="la la-angle-right" aria-hidden="true"></i>
    </li>
    <li (click)="onChangePage(maxPage)" [ngClass]="{ disabled: !(curPage < maxPage - 1) }">
        <i class="la la-angle-double-right" aria-hidden="true"></i>
    </li>
</ul>
